import { render, staticRenderFns } from "./tips.vue?vue&type=template&id=3374651f&scoped=true&"
import script from "./tips.vue?vue&type=script&lang=ts&"
export * from "./tips.vue?vue&type=script&lang=ts&"
import style0 from "./tips.vue?vue&type=style&index=0&id=3374651f&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3374651f",
  null
  
)

export default component.exports